import { Injectable } from '@angular/core';
import {
  ManagementZones,
  VraMap,
} from '@cropx-web/services/api-gateway/MachineDataApiService';
import { VriMap } from '@cropx-web/services/network/endpoints/FieldApiModels';
import {
  Action,
  Selector,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';

import { FieldVraSelectors } from '../../../state/field-vra.state';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace VraMapsPage {
  const type = 'VraMapsPage';

  export class SetActiveManagementZones {
    static readonly type = `[${type}] activeManagementZonesUuid`;
    constructor(public activeManagementZonesUuid: string) {}
  }
  export class SetActiveVraMap {
    static readonly type = `[${type}] SetActiveVraMap`;
    constructor(public uuid: string) {}
  }
  export class SetActiveVriMap {
    static readonly type = `[${type}] SetActiveVriMap`;
    constructor(public uuid: string) {}
  }
}

export interface VraMapsPageModel {
  activeManagementZonesUuid: string;
  activeVraMapUuid: string;
  activeVriMapUuid: string;
}

@State<VraMapsPageModel>({
  name: 'vraMapsPage',
  defaults: {
    activeManagementZonesUuid: null,
    activeVraMapUuid: null,
    activeVriMapUuid: null,
  },
})
@Injectable()
export class VraMapsPageState {
  constructor() {}

  @Action(VraMapsPage.SetActiveManagementZones)
  setActiveManagementZones(
    ctx: StateContext<VraMapsPageModel>,
    action: VraMapsPage.SetActiveManagementZones,
  ): void {
    ctx.patchState({
      activeManagementZonesUuid: action.activeManagementZonesUuid,
      activeVraMapUuid: null,
      activeVriMapUuid: null,
    });
  }
  @Action(VraMapsPage.SetActiveVraMap)
  SetActiveVraMap(
    ctx: StateContext<VraMapsPageModel>,
    action: VraMapsPage.SetActiveVraMap,
  ): void {
    ctx.patchState({
      activeManagementZonesUuid: null,
      activeVraMapUuid: action.uuid,
      activeVriMapUuid: null,
    });
  }
  @Action(VraMapsPage.SetActiveVriMap)
  SetActiveVriMap(
    ctx: StateContext<VraMapsPageModel>,
    action: VraMapsPage.SetActiveVriMap,
  ): void {
    ctx.patchState({
      activeManagementZonesUuid: null,
      activeVraMapUuid: null,
      activeVriMapUuid: action.uuid,
    });
  }
}

export class VraMapsPageSelectors {
  static slices = createPropertySelectors<VraMapsPageModel>(VraMapsPageState);

  @Selector([
    FieldVraSelectors.slices.managementZonesList,
    VraMapsPageSelectors.slices.activeManagementZonesUuid,
  ])
  static activeManagementZones(
    zones: ManagementZones[],
    uuid: string,
  ): ManagementZones | undefined {
    return zones?.find((d) => d.uuid === uuid);
  }

  @Selector([
    FieldVraSelectors.slices.vraMaps,
    VraMapsPageSelectors.slices.activeVraMapUuid,
  ])
  static activeVraMap(vraMaps: VraMap[], uuid: string): VraMap | undefined {
    return vraMaps?.find((d) => d.uuid === uuid);
  }

  @Selector([
    FieldVraSelectors.slices.vriMaps,
    VraMapsPageSelectors.slices.activeVriMapUuid,
  ])
  static activeVriMap(vriMaps: VriMap[], uuid: string): VriMap | undefined {
    return vriMaps?.find((d) => d.uuid === uuid);
  }

  @Selector([
    VraMapsPageSelectors.activeManagementZones,
    VraMapsPageSelectors.activeVraMap,
  ])
  static activeZones(zones, vra): ManagementZones {
    return zones || vra;
  }
}
